import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';


export default function DateTimePicker1({
    className = "w-100",
    disabled,
    labelAnimation=false, // A cimke nem ugrik be
    style={ backgroundColor: "white" },
    size="small",
    label,
    clearable=true,
    ...rest
}) {

    return (
        <DateTimePicker



            style={style}

            label={label}
            slotProps={{ 
                textField: { size: size },
                ...(clearable ? {actionBar: {actions: ['clear']}} : {}) 
            }}

            className={className}
            disabled={disabled}
            
            onAccept={(newDate) => {
                console.log(newDate);
            }}

            timePicker

            {...rest}
        />
    )
}